'use client';
import parse from 'html-react-parser';
import { CircleArrowSVG, CloseSVG } from 'components/svg';
import { GravityFormsType } from '@overlapdev/types';
import { useEffect, useState } from 'react';
import { googleTranslate } from '@overlapdev/functions';
import { getCookie, hasCookie } from 'cookies-next';
import GravityForm from '@overlapdev/gravity-forms';
import { LoadingSVG } from '@overlapdev/elements/assets';

const Slideout = ({}) => {
	//__State
	const [open, setOpen] = useState(false);
	const [content, setContent] = useState(null);
	const [error, setError] = useState(false);
	const [form, setForm] = useState<GravityFormsType | null>(null);
	const [loading, setLoading] = useState(false);

	//__Functions
	const getForm = async (id: string) => {
		setOpen(true);
		setLoading(true);
		const gform = await fetch(`/api/gforms?id=${id}`).then((res) => res.json());
		if (gform && !gform.error) {
			setForm(gform);
		} else {
			setError(true);
		}
		setLoading(false);
	};
	const getContent = async (id: string) => {
		setOpen(true);
		setLoading(true);
		const page = await fetch(`/api/pages?id=${id}`).then((res) => res.json());
		if (page?.id) {
			setContent(page.acf?.content);
		} else {
			setError(true);
		}
		setLoading(false);
	};

	const checkHash = (hash: string) => {
		const hash1 = hash.split('-')[0];
		const hash2 = hash.split('-')[1];
		if (hash1 === '#slideoutform' && hash2) {
			getForm(hash2);
		} else if (hash1 === '#slideoutcontent' && hash2) {
			getContent(hash2);
		}
	};

	const close = () => {
		setOpen(false);
		history.replaceState(null, '', '#');
		setTimeout(() => {
			setContent(null);
			setForm(null);
			setError(false);
			setLoading(false);
		}, 500);
	};

	//__Use Effect
	useEffect(() => {
		if (open) {
			document.body.style.overflow = 'hidden';
			document.body.style.height = '100%';
			//document.documentElement.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
			document.body.style.height = 'unset';
			//document.documentElement.style.overflow = 'unset';
		}
	}, [open]);

	useEffect(() => {
		if (window.location.hash) {
			checkHash(window.location.hash);
		}

		const handleHashChange = (e: any) => {
			e.preventDefault();
			checkHash(window.location.hash);
		};
		window.addEventListener('hashchange', handleHashChange);
		return () => window.removeEventListener('hashchange', handleHashChange);
	}, []);

	useEffect(() => {
		if (!loading && hasCookie(process.env.NEXT_PUBLIC_GOOGLE_TRANSLATE_COOKIE || '')) {
			const cookie = getCookie(process.env.NEXT_PUBLIC_GOOGLE_TRANSLATE_COOKIE || '')?.toString() || '';
			googleTranslate(cookie);
		}
	}, [loading]);

	return (
		<>
			<div className={`bg-black/50 duration-300 fixed left-0 top-0 transition-opacity z-50 ${open ? 'h-full opacity-100 w-full' : 'h-0 opacity-0 w-0'}`} onClick={() => close()} />
			<div className={`bg-white fixed p-5 pr-2 top-0 transition-ease w-full z-60 max-md:h-[95dvh] max-md:left-0 max-md:rounded-b-3xl md:h-full md:max-w-[720px] md:p-11 md:pr-5 md:rounded-l-3xl ${open ? ' max-md:top-0 md:right-0' : 'max-md:top-[-150%] md:-right-full'}`}>
				<div className='h-full overflow-auto pr-6'>
					{loading ? (
						<div className='flex h-full items-center justify-center'>
							<LoadingSVG width={200} fill='#373737' />
						</div>
					) : error ? (
						<div className='flex flex-col h-full items-center justify-center'>
							<h6>There was a problem loading the requested contents.</h6>
							<h6>Please close this slideout and try again.</h6>
						</div>
					) : form ? (
						<GravityForm form={form} form_title_tag='h5' section_heading_tag='h6' submit_children={<CircleArrowSVG width={18} />} />
					) : content ? (
						<div className='slideout_content'>{parse(content)}</div>
					) : null}
				</div>
				<div className='absolute cursor-pointer flex items-center justify-center h-10 right-6 rounded-full top-3 w-10 max-md:bg-dark-grey-30 md:border-[2px] md:border-black md:h-5 md:opacity-60 md:right-10 md:top-5 md:w-5' onClick={() => close()}>
					<CloseSVG className='w-4 md:w-2' />
				</div>
			</div>
		</>
	);
};

export default Slideout;
